import ApiService from "./api.service"

const TOKEN_KEY = 'access_token'
const REFRESH_TOKEN_KEY = 'refresh_token'
const INITIAL_DATA = 'initial_data'
const DOUBLE_VISITS = 'double_visits'
const SETTINGS = 'settings'

/**
 * Manage the how Access Tokens are being stored and retreived from storage.
 *
 * Current implementation stores to localStorage. Local Storage should always be
 * accessed through this instace.
 **/
const TokenService = {
    getToken() {
        return localStorage.getItem(TOKEN_KEY)
    },

    saveToken(accessToken) {
        localStorage.setItem(TOKEN_KEY, accessToken)
    },

    removeToken() {
        localStorage.removeItem(TOKEN_KEY)
    },

    getRefreshToken() {
        return localStorage.getItem(REFRESH_TOKEN_KEY)
    },

    saveRefreshToken(refreshToken) {
        localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken)
    },

    removeRefreshToken() {
        localStorage.removeItem(REFRESH_TOKEN_KEY)
    }

}


const InitialDataService = {
    refreshInitialData(initialDataFromServer) {
        localStorage.setItem(INITIAL_DATA, JSON.stringify(initialDataFromServer))
    },
    getInitialData() {
        return JSON.parse(localStorage.getItem(INITIAL_DATA))
    },
}

const DoubleVisitsService = {
    storeDoubleVisit(doubleVisit) {
        let stored = this.getDoubleVisits();
        //set created_at
        doubleVisit.created_at = (new Date()).toISOString().slice(0, 19).replace(/-/g, "/").replace("T", " ")

        if (stored) {
            stored.push(doubleVisit);
        } else {
            stored = [doubleVisit];
        }
        localStorage.setItem(DOUBLE_VISITS, JSON.stringify(stored))
    },
    getDoubleVisits() {
        return JSON.parse(localStorage.getItem(DOUBLE_VISITS))
    },
    removeDoubleVisits() {
        localStorage.removeItem(DOUBLE_VISITS)
    },
    async syncDoubleVisits() {
        let doubleVisits = this.getDoubleVisits();
        if (doubleVisits && doubleVisits.length > 0) {
            let request = {
                method: 'post',
                url: 'api/sync_local_double_visits',
                data: {'local_data': doubleVisits}
            }

            try {
                let response = await ApiService.customRequest(request);
                //no errors delete local visits
                this.removeDoubleVisits();
                console.log(response.data);
            } catch (e) {
                console.log(e.toString());
            }
        }
    }
}

const SyncDataService = {
    sync() {
        DoubleVisitsService.syncDoubleVisits();
    }
}

const SettingsService = {
    getSettings() {
        return JSON.parse(localStorage.getItem(SETTINGS))
    },
    saveSettings(data) {
        localStorage.setItem(SETTINGS, JSON.stringify(data))
    },
    getSetting(key) {
        let settings = this.getSettings() || {};
        return settings[key];
    },
    saveSetting(key, value) {
        let settings = this.getSettings() || {};
        settings[key] = value;
        this.saveSettings(settings);
    }
}

export {TokenService, InitialDataService, DoubleVisitsService, SyncDataService, SettingsService}
